@if (isCard) {
  <span class="td-data">
    <span class="sub-text"
      >{{ type }} By {{ user || '-' }} {{ date | date: 'MMM d, h:mm a' }}</span
    >
    <span *ngIf="showTimeZone" class="timezone">
      {{ timeZone }}
    </span>
  </span>
} @else {
  <span class="td-data">
    <span class="dark-text">{{
      date ? (date | date: 'MMM d YYYY, h:mm a') : '-'
    }}</span>
    <span *ngIf="user" class="sub-text">By {{ user || '-' }}</span>
    <span *ngIf="showTimeZone" class="timezone">
      {{ timeZone }}
    </span>
  </span>
}
